import { cn } from '@gettactic/helpers';
import React from 'react';
import { useFormControlWrapper } from './FormControlWrapperProvider';
import { FormControlLabelProps } from './defines';

export const FormControlLabel: React.FC<FormControlLabelProps> = (props) => {
  const { isInvalid } = useFormControlWrapper();
  const { children, className, isRequired, isOptional, ...rest } = props;
  const { id } = useFormControlWrapper();
  return (
    <label
      {...rest}
      className={cn(
        'flex w-full items-center justify-between space-x-2 text-secondary [.tactic-v2_&]:text-secondary-foreground',
        isInvalid && 'text-semantic-error-foreground',
        className
      )}
      htmlFor={props.htmlFor || id}
    >
      <span>
        {children}
        {isRequired ? (
          <span
            className={
              'inline-block px-1 font-bold text-semantic-error-foreground'
            }
          >
            *
          </span>
        ) : undefined}
      </span>
      {isOptional && <span className="text-muted-foreground">Optional</span>}
    </label>
  );
};
